import { assoc, pipe, ifElse, isNil, concat, merge, isEmpty, always } from 'ramda'

const intoObject = key => val => assoc(key, val, {})
const tokenToAuthHeader = ifElse(
  isNil,
  always(null),
  pipe(concat('Bearer '), intoObject('Authorization')),
)
export const makeHeaderOptions = headers =>
  pipe(tokenToAuthHeader, merge(headers), ifElse(isEmpty, always({}), intoObject('headers')))

const createDebugRequest = apiClient => ({ url, token, headers }) => {
  const options = makeHeaderOptions(headers)(token)

  return () => apiClient.get(url, options)
}

export default createDebugRequest
